import { editorialDefinition } from './editorial';
import type { LandingLayoutDefinition, LayoutId } from './types';

export const LAYOUT_DEFINITIONS: Record<LayoutId, LandingLayoutDefinition> = {
  editorial: editorialDefinition,
};

export const DEFAULT_LAYOUT_ID: LayoutId = 'editorial';

/** The brand a page shows before the partner sets one, for editors that start from it. */
export const DEFAULT_BRAND_COLOR = LAYOUT_DEFINITIONS[DEFAULT_LAYOUT_ID].tokens.brand;
